/* if adding a new flag, update use-record-all-flags.ts */

"use client";

import { usePostHogFlag } from "../use-posthog-flag";

export function useHasRewardsInterest(): boolean | undefined {
  return usePostHogFlag("has_rewards_interest");
}
